module.exports = __webpack_public_path__ + "png/logo.png?627ae7274db0a13bf0dc9b24996c5c22";